import React from 'react';
import { Modal, Field } from '../../components/ui';
import FunctionServices from './FunctionServices';

// Desktop add/edit Function dialog. Same three-column field grid as the generic
// CRUD modal, plus the catering / event-management panel underneath: a function
// is planned in one place - when it runs, where, who feeds the guests, at what
// rate and what is still owed. The panel needs a saved function to hang the
// services on, so it appears only when editing.
export default function FunctionFormDesktop({ vm, event }) {
  const { editing, values, fields, saving, setField, save, closeForm } = vm;
  if (!vm.open) return null;
  return (
    <Modal
      wide dense className="crud-form-modal"
      title={`${editing ? 'Edit' : 'Add'} Function`}
      onClose={closeForm}
      footer={<>
        <button className="btn light" onClick={closeForm}>Cancel</button>
        <button className="btn primary" disabled={saving} onClick={save}>{saving ? 'Saving…' : 'Save'}</button>
      </>}
    >
      <div className="form-grid cols-3">
        {fields.map(f => (
          <div key={f.key} style={{ gridColumn: f.span ? `span ${f.span}` : (f.half ? 'auto' : '1 / -1') }}>
            <Field
              label={f.label} type={f.type || 'text'} value={values[f.key]}
              options={f.options} required={f.required} rows={f.rows}
              onChange={(v) => setField(f, v)}
            />
          </div>
        ))}
      </div>

      {editing
        ? <FunctionServices event={event} fn={{ ...editing, ...values }} />
        : <div className="fn-services muted" style={{ fontSize: 12.5 }}>
            Save the function first — catering and the other services are added to it afterwards.
          </div>}
    </Modal>
  );
}
